// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3ljCw","header":"PatientQuestionnaire_header__3P50C","info":"PatientQuestionnaire_info__177Wb"};